// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sb-media_wrapper__by_xE","desktop":"sb-media_desktop__G6S7G","mobile":"sb-media_mobile__sazDu"};